"use strict";
import { breakpoint, tokens } from "../tokens/tokens-css";
function generateSpacing(property, negative, media) {
  const styles = {};
  for (const [spacing, size] of Object.entries(tokens.spacing)) {
    const value = negative ? `calc(${size} * -1)` : size;
    if (media) {
      styles[spacing] = {
        "@media": { [media]: { [property]: value } }
      };
    } else {
      styles[spacing] = { [property]: value };
    }
  }
  return styles;
}
export function makeRecipeSpacingVariants(property, negative) {
  const variants = {};
  variants[property] = generateSpacing(property, negative);
  for (const [bp, media] of Object.entries(breakpoint)) {
    variants[`${property}_${bp}`] = generateSpacing(property, negative, media);
  }
  return variants;
}
export function makeSpacingVariants(value) {
  const [property, spacing] = Object.entries(value)[0];
  if (!spacing) return {};
  if (typeof spacing === "string") {
    return { [property]: spacing };
  }
  const variants = {};
  for (const [key, value2] of Object.entries(spacing)) {
    if (key === "default") continue;
    variants[`${property}_${key}`] = value2;
  }
  if (spacing.default) {
    variants[property] = spacing.default;
  }
  return variants;
}
